import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BotDateRange } from '../../../core/models/bot.model';
import { DateRangeSelectionStrategy } from '../../utility/date-range-selection.strategy';

@Component({
  selector: 'brn-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DateRangeSelectionStrategy,
    },
  ],
})
export class DateRangePickerComponent {
  // tslint:disable-next-line: variable-name
  private _period!: BotDateRange;

  @Input()
  class?: string;

  @Input()
  set period(period: BotDateRange) {
    if (JSON.stringify(this.period) === JSON.stringify(period)) {
      return;
    }

    this._period = period;
    this.periodGroup.patchValue(this.period, { emitEvent: false });
  }

  get period(): BotDateRange {
    return this._period;
  }

  @Output()
  periodChange = new EventEmitter<BotDateRange>();

  periodGroup: FormGroup = this.fb.group({
    from: [undefined, [Validators.required]],
    to: [undefined, [Validators.required]],
  });

  constructor(private fb: FormBuilder) {
    this.periodGroup.valueChanges
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((value: BotDateRange) => {
        if (value.from && value.to) {
          if (value.from > value.to) {
            this.periodChange.emit({ from: value.to, to: value.from });
            return;
          }
          this.periodChange.emit(value);
        } else {
          this.periodChange.emit({ from: null, to: null });
        }
      });
  }
}
